import api from "./api";

export default class FavoritesAPi {
    static postFavorecido = async (obj: any) => {
        const response = await api.post(`/FavorecidoContas`, obj);
        return response.data;
    };

    static getFavorecidosList = async (Page: number, RecordsPerPage: number, idCliente: number, search: string = '') => {
        const response = await api.get(`/FavorecidoContas?Page=${Page}&RecordsPerPage=${RecordsPerPage}&idCliente=${idCliente}&search=${search}`);
        return response;
    };    

    static deleteFavorecidoPerId = async (id: number) => {
        const response = await api.delete(`/FavorecidoContas/${id}`);
        return response.data;
    };

    static updateFavorecido = async (id: number, obj:any) => {
        const response = await api.put(`/FavorecidoContas/${id}`,obj);
        return response.data;
    };

    static getFavorecidosById = async (id: number) => {
        const response = await api.get(`/FavorecidoContas/${id}`);
        return response;
    };    
};

